export default __webpack_public_path__ + "d65913bd1241e4ac7ca4ab6e81ef2975.svg";